<template>
    <div id="root">
        
        <main>
            <div class="container">
              <div class="row h-100">
                <div class="col-lg-6 mx-auto my-auto">
                  <b-card class="auth-card" no-body>

                      <div class="form-side">
                        <router-link tag="a" to="/"><span class="logo-single"/></router-link>
                        <h6 class="mb-4">Whoops! Nothing there...</h6>
                        <p class="mb-0 text-muted text-small mb-0">Not Found</p>
                        <p class="display-1 font-weight-bold mb-5">404</p>
                        <b-button type="submit" variant="primary" size="lg" class="btn-shadow" @click="goBack">Back</b-button>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
        </main>
     
    </div>
</template>
<script>
export default {
  methods: {
    goBack () {
      this.$router.push('/')
    }
  },
 
}
</script>
